<div *ngIf="allowUploads">
  <input #inputFile type="file" ng2FileSelect [uploader]="uploader" [accept]="extensionType"/>
  <button type="button" class="btn btn-success btn-s" (click)="onUpload()"
    [disabled]="!uploader.getNotUploadedItems().length">
    <span class="fa fa-upload"></span> Upload
  </button>
</div>
